import { branch, compose, renderNothing, withProps } from 'recompose'
import { connect } from 'react-redux'
import {
  selectCustomerPhone,
  selectCustomerProfile
} from 'src/store/selectors/customerProfile'
import { safeExternal } from 'src/helpers/links'

const CardProContainer = compose(
  connect(state => ({
    customerPhone: selectCustomerPhone(state),
    customerProfile: selectCustomerProfile(state)
  })),
  branch(({ customerProfile }) => !customerProfile, renderNothing),
  withProps(({ customerProfile }) => {
    const { officeProfile = {} } = customerProfile
    const { corporateProfile = {} } = officeProfile
    const customerLinkedin = customerProfile.linkedinUri

    return {
      companyName: corporateProfile.name,
      customerEmail: customerProfile.email,
      customerLinkedin,
      customerName: `${customerProfile.firstName} ${customerProfile.lastName}`,
      customerNmls: customerProfile.nmls,
      customerPhoto: customerProfile.photoUri,
      customerStateLicense: customerProfile.stateLicense,
      customerTitle: customerProfile.title,
      customerWebsite: safeExternal(customerProfile.websiteUri),
      officeAddress: corporateProfile.showAddress
        ? officeProfile.address
        : null,
      officeName: officeProfile.name,
      officeNmls: officeProfile.nmls
    }
  })
)

export default CardProContainer
